// previously useRapidOrderStatus.ts
import type { OrderDetails } from '@/entities/order/model'
import type { DisplayState } from '@/entities/state/model'
import { useMemo } from 'react'
import { useSidebarOrderPanels } from '@/entities/state/model'
import { getPanelOrderStatus } from './order.panel-context'

interface UsePanelOrderStatusProps {
  order: OrderDetails
  displayState?: DisplayState
  withoutBackdrop?: boolean
}

export function usePanelOrderStatus({ order, displayState, withoutBackdrop }: UsePanelOrderStatusProps) {
  const { data: panels = [], isPending } = useSidebarOrderPanels()
  const panelStatuses = useMemo(
    () => new Set(panels.flatMap(p => p.states)),
    [panels],
  )
  if (isPending) {
    return { isPanelOrderContext: false, statusText: order.status, statusDisplayState: displayState }
  }
  return getPanelOrderStatus({ order, displayState, withoutBackdrop, panelStatuses })
}
